import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { useNavigate } from 'react-router-dom';
import { setSaveSortingChanges, setSaveSortingTrigger } from '../../../store/adminSlices/rallies';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { generateIdRoutePath } from '../../../helpers';
const UnsavedSortingChanges = ({ rallyId, saveSortingTrigger }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content unsaved-sorting-changes', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.unsaved_sorting_changes'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.save_changes'), onClick: () => {
                                dispatch(setSaveSortingChanges(true));
                                dispatch(setSaveSortingTrigger(saveSortingTrigger));
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            } }), _jsx(Button, { variant: 'outlined', label: t('button.continue_without_saving'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                                if (saveSortingTrigger === 'create-task') {
                                    navigate(generateIdRoutePath(APP_ROUTES.adminCreateTask, rallyId));
                                }
                                else if (saveSortingTrigger === 'page-out' ||
                                    saveSortingTrigger === 'publish-rally') {
                                    navigate(APP_ROUTES.adminManageRallies);
                                }
                            } })] }) })] }));
};
export default UnsavedSortingChanges;
